//@flow
import React from 'react'
import classnames from 'classnames'

import { useToggleStyles } from './styles'

type ToggleProps = {
  id?: string,
  label?: string,
  name?: string,
  isDisabled?: boolean,
  isBordered?: boolean,
  checked?: boolean,
  toggleProps?: { [key: string]: any },
  onChange: (event: SyntheticEvent<HTMLInputElement>) => void
}

const Toggle = ({ id, label, name, isDisabled, isBordered, onChange, checked, toggleProps, ...props }: ToggleProps) => {
  const classes = useToggleStyles()

  return (
    <label
      className={classnames(classes.toggleWrapper, {
        bordered: isBordered,
        disabled: isDisabled,
        checked: checked
      })}
      {...props}
    >
      {label && <span className="toggle-label">{label}</span>}
      <div className={classes.toggle} {...toggleProps}>
        <input checked={!!checked} id={id} name={name} type="checkbox" onChange={onChange} />
        <span className="toggle-slider" />
      </div>
    </label>
  )
}

export default Toggle
